import React, { PropsWithChildren } from 'react';
import { UpdateSearchQuery } from '~/core/useSearchState';

export interface SearchQueryContext {
    searchQuery: string;
    updateSearchQuery: UpdateSearchQuery;
}

const SearchQueryContext = React.createContext<undefined | SearchQueryContext>({
    searchQuery: '',
    updateSearchQuery: () => null,
});

export const SearchQueryProvider: React.FC<PropsWithChildren<SearchQueryContext>> = ({
    children,
    searchQuery,
    updateSearchQuery,
}) => {
    return (
        <SearchQueryContext.Provider value={{ searchQuery, updateSearchQuery }}>{children}</SearchQueryContext.Provider>
    );
};

export const useSearchQuery = (): SearchQueryContext => {
    const context = React.useContext(SearchQueryContext);

    if (context === undefined) {
        throw new Error('useSearchQuery must be used within a SearchQueryProvider');
    }

    return context;
};
